import React from "react";
import Icon1 from "../icons/Icon";

const PlanComparison = () => {
  // Sample data structure - replace with your actual data
  const plans = [
    { id: "starter", name: "Starter" },
    { id: "business", name: "Business" },
    { id: "premium", name: "Premium" },
  ];

  const features = [
    {
      name: "Gestion de dossiers",
      availability: {
        premium: "illimitée",
      },
    },
    {
      name: "Commission de paiements",
      availability: {
        premium: "2%",
      },
    },
    {
      name: "Paiement clients particulier",
      availability: {
        premium: true,
      },
    },
    {
      name: "Invitation partenaires (Clients, BE, artisans)",
      availability: {
        premium: true,
      },
    },
    {
      name: "Communication par chat",
      availability: {
        premium: true,
      },
    },
    {
      name: "Notifications emails",
      availability: {
        premium: true,
      },
    },
    {
      name: "Relance automatique des pièces",
      availability: {
        premium: true,
      },
    },
    {
      name: "Génération d'attestations isolant/carbone",
      availability: {
        premium: true,
      },
    },
    {
      name: "Génération d'attestations sur l'honneur",
      availability: {
        premium: true,
      },
    },
    {
      name: "Génération d'attestations conformité RT Batiment",
      availability: {
        premium: true,
      },
    },

    {
      name: "Demande de prise de rendez-vous",
      availability: {
        premium: true,
      },
    },
    {
      name: "Portail clients particuliers",
      availability: {
        premium: true,
      },
    },
    {
      name: "Accès au forum de la communauté",
      availability: {
        premium: true,
      },
    },
    {
      name: "Stockage illimité",
      availability: {
        premium: true,
      },
    },
    {
      name: "Rappels automatiques par sms",
      availability: {
        premium: true,
      },
    },
    {
      name: "Planning des interventions",
      availability: {
        premium: true,
      },
    },
    {
      name: "Application mobile terrain",
      availability: {
        premium: true,
      },
    },
    {
      name: "Signatures illimitées",
      availability: {
        premium: true,
      },
    },
    {
      name: "Devis automatiques",
      availability: {
        premium: true,
      },
    },
    {
      name: "Suivi commercial",
      availability: {
        premium: true,
      },
    },
    {
      name: "Statistiques annuels",
      availability: {
        premium: true,
      },
    },
    {
      name: "Génération du rapport de contrôle",
      availability: {
        premium: true,
      },
    },
    {
      name: "Rapport de résumé de visite automatisé",
      availability: {
        premium: true,
      },
    },
    {
      name: "Intégration Pennylane",
      availability: {
        premium: true,
      },
    },
    {
      name: "Widget devis sur votre site",
      availability: {
        premium: true,
      },
    },
  ];

  return (
    <div className="w-full max-w-c1k h-fit mx-auto p-6">
      <div className="grid grid-cols-1 md:grid-cols-3 h-fit gap-6">
        {/* Plan Headers */}

        {/* Features Comparison */}
        <div className="col-span-full h-fit bg-white rounded-lg shadow-md overflow-hidden">
          <table className="w-full">
            <tbody>
              {features.map((feature, index) => (
                <tr
                  key={feature.name}
                  className={index % 2 === 0 ? "bg-gray-50" : "bg-white"}
                >
                  <td className="p-4  text-h2 text-gray-700 border-b border-gray-200">
                    {feature.name}
                  </td>
                  {plans.map((plan) => (
                    <td
                      key={`${feature.name}-${plan.id}`}
                      className="p-4 border-b border-gray-200"
                    >
                      {typeof feature.availability[plan.id] === "boolean" ? (
                        feature.availability[plan.id] === true ? (
                          <Icon1
                            icon_name="done"
                            size={18}
                            fill="black"
                          ></Icon1>
                        ) : feature.availability[plan.id] === false ? (
                          <Icon1
                            icon_name="done"
                            size={18}
                            fill="lightgrey"
                          ></Icon1>
                        ) : (
                          feature.availability[plan.id]
                        )
                      ) : feature.availability[plan.id] === "illimitée" ? (
                        <span className="text-green-500 font-semibold">
                          <Icon1 icon_name="infini" fill="black"></Icon1>
                        </span>
                      ) : (
                        <span className=" text-h2 font-semibold">
                          {feature.availability[plan.id]}
                        </span>
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default PlanComparison;
